// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deeper-view-main {\n    display: flex;\n    flex-flow: column;\n    margin-top: 10px;\n    min-height: calc(100vh - 200px);\n}\n\n.deeper-view-chart {\n    min-height: 350px;\n    width: 100%;\n}\n\n.deeper-view-chart-controls {\n    display: flex;\n    align-items: flex-start;\n    margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
